module.exports = __webpack_public_path__ + "media/cuu/ppal_cuu_1-e49ed0ad.png";